module.exports = __webpack_public_path__ + "img/horizontal_7_1_5010.927ac671.png";